import http from '@/api/http';
export default {
    veriy(cart){
        return http({url:"/coupon/"+ cart.coupon.trim() +"/verify", method:"post", data : cart})
    }
}